export const contactFormData = {
    errors: {
        requiredMessage: 'Pole nie może być puste',
        patternMessage: 'Adres e-mail jest niepoprawny'
    }
};
